document.addEventListener("DOMContentLoaded", function () {
  const searchContainers = document.querySelectorAll(
    ".custom-search__container"
  );
  for (let index = 0; index < searchContainers.length; index++) {
    const container = searchContainers[index];
    const searchBtn = container.querySelector(".custom-search__btn");
    const searchForm = container.querySelector(".custom-search__form");

    searchBtn.addEventListener("click", function () {
      const isActive = container.classList.toggle(
        "custom-search__container--active"
      );
      searchBtn.setAttribute("aria-expanded", isActive);
      if (isActive) {
        searchForm.querySelector(".custom-search__input").focus();
      }
    });
  }
});
